import { Box, Container, Typography, Button, Stack, styled } from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import PublishIcon from '@mui/icons-material/Publish';
import { useNavigate } from 'react-router-dom';
import { useTenantConfig } from '../hooks/useTenant';

const SectionBadge = styled(Box)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 16px',
    borderRadius: 50,
    background: 'rgba(30, 64, 175, 0.06)',
    border: '1px solid rgba(30, 64, 175, 0.12)',
    marginBottom: 20,
});

const S = { main: '#1e40af', light: '#3b82f6', dark: '#1e3a8a', accent: '#0891b2' };

const WidgetFreedomSectionKurumsal = () => {
    const {colors, tenantName,widget_video_url} = useTenantConfig();
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                pt: { xs: 16, md: 14 },
                pb: { xs: 10, md: 14 },
                position: 'relative',
                background: '#ffffff',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1.1fr 1fr' },
                        gap: 1,
                        alignItems: 'center',
                    }}
                >
                    {/* LEFT SIDE */}
                    <Box>
                        <SectionBadge>
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: '#0891b2',
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: '0.8rem',
                                    fontWeight: 600,
                                    color: '#0891b2',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                ÖZGÜR TASARIM DENEYİMİ
                            </Typography>
                        </SectionBadge>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 800,
                                    fontSize: { xs: '2.4rem', md: '3rem' },
                                    color: '#0f172a',
                                    lineHeight: 1.2,
                                    letterSpacing: '-0.02em',
                                    mb: 2.5,
                                }}
                            >
                                Web Sitenizi {' '}
                                <br/>
                                <Box
                                    component="span"
                                    sx={{
                                        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight: 800,
                                    }}
                                >
                                   Özgürce 
                                   <br/>
                                   Tasarlayın
                                </Box>
                            </Typography>

                        <Box sx={{ mb: 5 }}>
                            <Typography
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '1.05rem',
                                    lineHeight: 1.8,
                                    mb: 2,
                                }}
                            >
                                Sıradan ve kopya web sitelerinden kurtulun. {tenantName} ile premium ve tamamen size özel bir web sitesine sahip olun.
                            </Typography>
                            <Typography
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '1.05rem',
                                    lineHeight: 1.8,
                                }}
                            >
                                Şablon sınırları yok. Öğeleri dilediğiniz gibi kaydırın, ekranda doğrudan düzenleyin ve sitenizi özgürce tasarlayın.
                            </Typography>
                        </Box>

                        <Stack spacing={4} sx={{ mb: 5 }}>
                            <Stack spacing={1}>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <ViewModuleIcon color="primary" />
                                    <Typography fontWeight={600} color="text.primary">
                                        Widget Seçin
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" color="text.secondary" sx={{ pl: 5, lineHeight: 1.7 }}>
                                    Bağış, etkinlik, proje, galeri gibi içerikleri sayfanıza ekleyin.
                                </Typography>
                            </Stack>

                            <Stack spacing={1}>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <DragIndicatorIcon color="primary" />
                                    <Typography fontWeight={600} color="text.primary">
                                        Sayfanızı Oluşturun
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" color="text.secondary" sx={{ pl: 5, lineHeight: 1.7 }}>
                                    Widget'ları istediğiniz yere sürükleyip bırakarak sayfa düzeninizi belirleyin.
                                    Tüm değişiklikler web sitenizde anında yayınlanır.
                                </Typography>
                            </Stack>

                            <Stack spacing={1}>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <PublishIcon color="primary" />
                                    <Typography fontWeight={600} color="text.primary">
                                        Anında Yayınlayın
                                    </Typography>
                                </Stack>
                                <Typography variant="body2" color="text.secondary" sx={{ pl: 5, lineHeight: 1.7 }}>
                                    Yaptığınız her değişiklik otomatik olarak kaydedilir ve yayına alınır.
                                </Typography>
                            </Stack>
                        </Stack>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/ozellikler/web')}
                            sx={{
                                px: 4,
                                py: 1.5,
                                fontWeight: 600,
                                fontSize: '1rem',
                                color: S.main,
                                borderColor: S.main,
                                borderRadius: 2,
                                borderWidth: 2,
                                textTransform: 'none',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    borderWidth: 2,
                                    borderColor: S.main,
                                    background: `linear-gradient(135deg, ${S.main} 0%, ${S.light} 100%)`,
                                    color: 'white',
                                    transform: 'translateY(-2px)',
                                    boxShadow: `0 8px 24px rgba(8, 145, 178, 0.25)`,
                                },
                            }}
                        >
                            Özgür Tasarımı Keşfet
                        </Button>
                    </Box>

                    {/* RIGHT SIDE */}
                    <Box>
                        {/* Header Badge */}
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 1.5,
                                px: 2.5,
                                py: 1.2,
                                mb: 2.5,
                                borderRadius: '12px',
                                background: `linear-gradient(135deg, rgba(30, 64, 175, 0.08) 0%, rgba(8, 145, 178, 0.08) 100%)`,
                                border: `1.5px solid rgba(30, 64, 175, 0.2)`,
                                boxShadow: '0 2px 8px rgba(30, 64, 175, 0.1)',
                            }}
                        >
                            <Box
                                sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: '50%',
                                    background: `linear-gradient(135deg, ${S.main} 0%, ${S.accent} 100%)`,
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: '0.9rem',
                                    fontWeight: 700,
                                    background: `linear-gradient(135deg, ${S.main} 0%, ${S.accent} 100%)`,
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    letterSpacing: '0.3px',
                                }}
                            >
                                Bakarak Tasarla
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                background:
                                    'linear-gradient(145deg, #f8fafc 0%, #eef2f7 100%)',
                                boxShadow: '0 30px 60px rgba(0,0,0,0.06)',
                                position: 'relative',
                            }}
                        >
                            <Box
                                component="video"
                                autoPlay
                                loop
                                muted
                                playsInline
                                src={widget_video_url}
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                    display: 'block',
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default WidgetFreedomSectionKurumsal;